/**
 * Shared detection class colors for consistent display across all camera views
 * Colors are chosen to be distinct and visually appealing
 */

export const DETECTION_CLASS_COLORS: Record<string, string> = {
  // Generic/fallback
  'cosmetics': '#FF6B6B',           // Coral red

  // Cosmetics - Warm colors
  'CeraveFoamCleanser': '#4ECDC4',   // Teal
  'CeraveCleanser': '#4ECDC4',       // Teal (Boots v4.2 variant)
  'ChanelOmbreEssentielle': '#FFE66D', // Gold
  'MACLipstick': '#FF6B9D',          // Pink
  'MACMascara': '#C44569',           // Magenta
  'NiveaCreme': '#1E3A8A',           // Dark blue (Nivea brand color)
  'TangleTeezerPinkClassic': '#FF9F43', // Orange

  // Nespresso pods - Purple/Blue spectrum (coffee theme)
  'NespressoAltissio': '#6C5CE7',    // Purple
  'NespressoArpeggio': '#9B59B6',    // Deep purple (Arpeggio is purple pod)
  'NespressoStormio': '#74B9FF',     // Light blue
  'NespressoVolluto': '#F1C40F',     // Gold/Yellow (Volluto is gold pod)
  'NespressoClassic': '#8B4513',     // Brown (Original line)
  'NespressoVertuo': '#5D3FD3',      // Iris purple (Vertuo line)
  'Vertuo': '#5D3FD3',               // Iris purple (TREYv4.2 variant)

  // TREYv3 legacy Nespresso classes
  'NespressoGoldPod': '#F1C40F',     // Gold
  'NespressoPurplePod': '#9B59B6',   // Purple
  'coffee-pods': '#8B4513',          // Brown (generic coffee)

  // Boots v4.2 specific classes
  'N7Mascara': '#2ECC71',            // Emerald green (No7 brand)
  'SimpleScrub': '#3498DB',          // Blue (Simple brand)
  '17Powder': '#E91E63',             // Pink (17 cosmetics brand)
};

/**
 * Get color for a detection class, with fallback to white
 */
export function getDetectionColor(className: string): string {
  return DETECTION_CLASS_COLORS[className] || '#FFFFFF';
}

/**
 * Default box style settings
 */
export const BBOX_STYLE = {
  lineWidth: 2,
  labelFont: 'bold 10px Arial',
  labelHeight: 14,
  labelPadding: 3,
};
